import { clsx, type ClassValue } from "clsx"
import { twMerge, extendTailwindMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
   return twMerge(clsx(inputs))
}

export function cnWithPrefix(prefix: string) {
   const twMergeWithPrefix = extendTailwindMerge({
      prefix
   })
   return (...inputs: ClassValue[]) => {
      return twMergeWithPrefix(clsx(inputs))
   }
}
